import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/page-header";
import { KpiCard } from "@/components/kpi-card";
import { StatusBadge } from "@/components/status-badge";
import { NewInvoiceDialog } from "@/components/forms/new-invoice-dialog";
import { invoices, fmtUsd } from "@/mocks/data";

export const Route = createFileRoute("/invoices")({
  head: () => ({
    meta: [
      { title: "Invoices — Studio OS" },
      { name: "description", content: "Invoicing, payments, and outstanding balances." },
    ],
  }),
  component: InvoicesPage,
});

function InvoicesPage() {
  const outstanding = invoices.filter((i) => i.status === "sent" || i.status === "overdue")
    .reduce((s, i) => s + i.amount, 0);
  const paid = invoices.filter((i) => i.status === "paid").reduce((s, i) => s + i.amount, 0);
  const overdue = invoices.filter((i) => i.status === "overdue").reduce((s, i) => s + i.amount, 0);

  return (
    <div className="mx-auto max-w-7xl px-6 py-8 lg:px-10 lg:py-10">
      <PageHeader
        title="Invoices"
        description="Money in and money owed."
        actions={<NewInvoiceDialog />}
      />
      <div className="mb-8 grid grid-cols-1 gap-4 md:grid-cols-3">
        <KpiCard label="Outstanding" value={fmtUsd(outstanding)} hint="Sent + overdue" />
        <KpiCard label="Paid" value={fmtUsd(paid)} hint="This quarter" />
        <KpiCard accent label="Overdue" value={fmtUsd(overdue)} hint="Action required" />
      </div>
      <div className="overflow-hidden rounded-xl bg-card ring-1 ring-border">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-border bg-surface-muted/50">
            <tr className="text-[11px] uppercase tracking-wider text-muted-foreground">
              <th className="px-4 py-3 font-medium">Invoice</th>
              <th className="px-4 py-3 font-medium">Client</th>
              <th className="px-4 py-3 font-medium">Issued</th>
              <th className="px-4 py-3 font-medium">Due</th>
              <th className="px-4 py-3 font-medium">Amount</th>
              <th className="px-4 py-3 text-right font-medium">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {invoices.map((i) => (
              <tr key={i.id} className="transition hover:bg-surface-muted/40">
                <td className="px-4 py-3 font-mono text-xs font-medium">{i.number}</td>
                <td className="px-4 py-3">{i.client}</td>
                <td className="px-4 py-3 font-mono text-xs text-muted-foreground">{i.issued}</td>
                <td className="px-4 py-3 font-mono text-xs text-muted-foreground">{i.due}</td>
                <td className="px-4 py-3 font-mono font-medium">{fmtUsd(i.amount)}</td>
                <td className="px-4 py-3 text-right"><StatusBadge status={i.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
